import { uiText } from '../i18n/uiText';
export const formatFileSize = (size) => {
  if (size == null) return '—';
  if (size < 1024) return `${size} Б`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} КБ`;
  return `${(size / (1024 * 1024)).toFixed(1)} МБ`;
};

export const getFileKind = (file) => {
  const ext = (file.extension || file.original_name || file.filename || '').toLowerCase();
  if (/(jpg|jpeg|png|webp|gif|bmp|svg)$/.test(ext)) return 'image';
  if (/(xls|xlsx|ods|csv)$/.test(ext)) return 'spreadsheet';
  if (/(doc|docx|txt|pdf)$/.test(ext)) return 'document';
  if (/(ppt|pptx)$/.test(ext)) return 'presentation';
  if (/(zip|rar|7z)$/.test(ext)) return 'archive';
  return file.category || 'file';
};

export const FILE_KIND_LABELS = {
  image: uiText("Изображение"), document: uiText("Документ"), spreadsheet: uiText("Таблица"),
  presentation: uiText("Презентация"), archive: uiText("Архив"), file: uiText("Другой файл"),
};

export function fileKindLabel(file) {
  return FILE_KIND_LABELS[getFileKind(file)] || FILE_KIND_LABELS.file;
}
